import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import RankerXLink from "components/RankerXLink";
import {
	Table,
	Card,
	Form,
	Button,
	Row,
	Icon,
	Popconfirm,
	Spin,
	Divider,
	Tooltip
} from "antd";

import PageHeaderLayout from "layouts/PageHeaderLayout";
import AddEditStrategyDialog from "./components/AddEditStrategyDialog";
import ImportFilesDialog from "components/ImportFilesDialog";
import { locationPrefix } from "common/general";
import DuplicateStrategyDialog from "./components/DuplicateStrategyDialog";


const FormItem = Form.Item;

@inject("rootStore")
@observer
class StrategiesPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRowKeys: []
		};
	}

	deleteStrategies = () => {
		const {
			rootStore: { strategiesStore }
		} = this.props;

		strategiesStore.remoteDeleteStrategies(this.state.selectedRowKeys);
	};

	showAddStrategyDialog = () => {
		const {
			rootStore: { strategiesStore }
		} = this.props;
		strategiesStore.showAddStrategyDialog();
	};

	showEditStrategyDialog = e => {
		const {
			rootStore: { strategiesStore }
		} = this.props;

		strategiesStore.showEditStrategyDialog({
            id: e.currentTarget.dataset.id,
			name: e.currentTarget.dataset.name,			
		});
	};

	showDuplicateStrategyDialog = e => {
		const {
			rootStore: { strategiesStore }
		} = this.props;

		strategiesStore.showDuplicateStrategyDialog({
            id: e.currentTarget.dataset.id,
			name: "Copy of " + e.currentTarget.dataset.name,			
		});
	};

	showImportStrategiesDialog = () => {
		const {
			rootStore: { strategiesStore }
		} = this.props;

		strategiesStore.showImportStrategiesDialog();
	};

	hideImportStrategiesDialog = () => {
		const {
			rootStore: { strategiesStore }
		} = this.props;

		strategiesStore.hideImportStrategiesDialog();
	};

	render() {
		const {
			rootStore: { strategiesStore }
		} = this.props;

		const ui = strategiesStore.ui;

		const columns = [
			// {
			// 	title: "ID",
			// 	dataIndex: "id",
			// 	width: 120,
			// 	defaultSortOrder: "descend",
			// 	sorter: (a, b) => a.id - b.id
			// },
			{
				title: "Name",
				dataIndex: "name",
				defaultSortOrder: "ascend",
				sorter: (a, b) => (a.name > b.name ? 1 : -1),
				render: (text, record) => {
					// return <Link to={"/campaign/" + record.id}>{text}</Link>;
					return (
						<RankerXLink
							routeName="strategy"
							params={{ id: record.id.toString() }}
						>
							{text}
						</RankerXLink>
					);
				}
			},
			{
				title: "Type",
				dataIndex: "type",
				sorter: (a, b) => (a.type > b.type ? 1 : -1),
				render: (text, record) => {
					if (text == undefined || text == null) {
						return "CUSTOM";
					} else {
						return text;
					}
				}
			},
			{
				title: "Action",
				render: (text, record) => {
					if (record.type != undefined && record.type == "BUILTIN") {
						return (<span>
							<Tooltip title="Clone Diagram">
									<a
										type="primary"										
										data-name={record.name}
										data-id={record.id}
										onClick={this.showDuplicateStrategyDialog}
									>
										<Icon type="copy" />
									</a>
							</Tooltip>
						</span>);
					}
					let strategy = record;
					let exportStrategyLink =
					"/action/export/strategies/" + strategy.id;
					return (
						<span>
							<Tooltip title="Rename">
								<a	
									type="primary"
									data-name={record.name}
									data-id={record.id}
									onClick={this.showEditStrategyDialog}
								>
									<Icon type="edit" />
								</a>	
							</Tooltip>
							<Divider type="vertical" />
							<Tooltip title="Download Diagram">
								<a
									type="primary"
									href={exportStrategyLink}
								>
									<Icon type="download" />
								</a>
							</Tooltip>
							<Divider type="vertical" />
							<Tooltip title="Clone Diagram">
									<a
										type="primary"										
										data-name={record.name}
										data-id={record.id}
										onClick={this.showDuplicateStrategyDialog}
									>
										<Icon type="copy" />
									</a>
							</Tooltip>
						</span>
					);
				}
			}			
		];
		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({ selectedRowKeys });
			},
			getCheckboxProps: record => ({
				disabled: record.type == "BUILTIN",
				name: record.name
			})
		};

		let spinning = ui.loadingStrategies == true || ui.deletingStrategies == true;
        const strategies = toJS(strategiesStore.strategies);
        
		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			}
		];
		return (
			<Fragment>
				{ui.loadingStrategies == true ? (
					""
				) : (
					<PageHeaderLayout breadcrumbList={breadcrumbList} title="Diagrams">
						<Card>							
							<AddEditStrategyDialog />
							<DuplicateStrategyDialog />
							<ImportFilesDialog
								dialogVisible={ui.importStrategiesDialogVisible}
								uploadingFiles={ui.importingStrategies}
								hideDialog={this.hideImportStrategiesDialog}
								multiple={true}
								title="Import Diagrams"
								hint="You can import multiple diagrams files or a ZIP file"
								uploadUrl={
									"/action/import/strategies"
								}
							/>
							<Spin spinning={spinning}>
								<Row>
									<Form layout="inline" style={{ marginBottom: 8 }}>
										<FormItem>
											<Button
												type="primary"
												onClick={this.showAddStrategyDialog}
											>
												<Icon type="plus-square-o" />
											</Button>
										</FormItem>
										<FormItem>
											<Tooltip title="Upload Diagrams">
												<Button
													type="primary"
													onClick={this.showImportStrategiesDialog}
												>
													<Icon type="upload" />
												</Button>
											</Tooltip>
										</FormItem>
										<FormItem>
											<Popconfirm
												title="Do you want to delete the selected diagrams?"
												place
												ment="bottom"
												onConfirm={this.deleteStrategies}
											>
												<Button
													type="primary"
													disabled={this.state.selectedRowKeys.length == 0}
												>
													<Icon type="delete" />
												</Button>
											</Popconfirm>
										</FormItem>
									</Form>
								</Row>
								<Row>
									<Table
										rowKey="id"
										rowSelection={rowSelection}
										columns={columns}
										dataSource={strategies}
										pagination={{
											pageSize: 100
										}}
									/>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}

export default StrategiesPage;